import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { ContentSpacing } from '@estee/elc-base-theme';
import { RemoveIcon } from '@estee/elc-icons';

import { IAccountSideBar } from '~exported/account-sidebar/AccountSidebar';
import { classes } from '~utils/Classes';

export const TEST_ID_SIDEBAR_CLOSE = 'account-sidebar-close-button';

export interface ISidebarControls {
    hideOverlay: IAccountSideBar['viewController']['hideOverlay'];
    closeBtnRef: React.RefObject<HTMLButtonElement>;
}

const ResetButtonStyle = styled.button`
    background: none;
    border: none;
    &:hover {
        background: none;
        border: none;
    }
    &:focus {
        outline: rgb(0, 0, 0) thin dotted;
    }
`;

const CloseButton = styled(ResetButtonStyle)`
    opacity: 0.7;
    position: absolute;
    right: ${ContentSpacing.space16};
    top: ${ContentSpacing.space16};
`;

const CloseIcon = styled(RemoveIcon)`
    width: 16px;
    height: 16px;
`;
const sidebarCloseClass = classes('account-sidebar-close');

export const SidebarControls = observer(function SidebarControls({
    hideOverlay,
    closeBtnRef
}: ISidebarControls) {
    return (
        <CloseButton
            aria-label="Close sidebar"
            className={sidebarCloseClass}
            data-test-id={TEST_ID_SIDEBAR_CLOSE}
            onClick={hideOverlay}
            ref={closeBtnRef}
        >
            <CloseIcon />
        </CloseButton>
    );
});
